module.exports = __webpack_public_path__ + "static/media/coins.66488971.jpg";